import { useAtomValue } from 'jotai';
import { loyaltyDataAtom } from '../../atoms';

export const useLoyaltyData = () => useAtomValue(loyaltyDataAtom);
